import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Lib } from 'app/lib/lib';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private lib: Lib,
    // private userService: UserService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        console.log('ERROR', err);
        if ([400, 401, 403, 404].indexOf(err.status) > -1) {
          if (err.error === 'authentication-failed') return throwError(`errors.${err.error}`)
          if (err.error === 'password-mismatch') return throwError(`errors.${err.error}`)
          if (err.statusText === 'Not Found') return throwError(`errors.backend-notfound`)  // 404
          if (err.statusText === 'Bad Request') return throwError(`errors.bad-request`)  // 400
          if (err.status === 401) this.router.navigate(['/auth/login']);



          // this.lib.router.navigate(['/misc/not-authorized']);
          // ? Can also logout and reload if needed
          // BUNU AÇMA LOOP'A GİRİYOR
          // this.lib.logout();
          // location.reload();
        }
        // throwError
        const error = err.error?.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
